export default __webpack_public_path__ + "static/media/Page_17.426182bf.png";